import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/auth'
import * as tools from './tools'

const http = axios.create({
  baseURL: '/',
  timeout: 30000,
  withCredentials: true
})

export default http
